export default __webpack_public_path__ + "static/media/welcome_bg@3x.43534b8e.png";